import { createContext, useContext } from 'react';

export const BonusDetailContext = createContext({ bonus: null, loading: false });

export const useBonusDetailContext = () => useContext(BonusDetailContext);
